<div class="overlay dashOverlay" *ngIf="showManagementMenu || showMyAccountMenu || showPurchasesMenu || showDocumentsMenu || showReportsMenu || showSettingsMenu || showCCPMenu" (click)="CloseDashMenu();"></div>
<div class="overlay animated fadeIn" *ngIf="ShowOverdueInvoiceNotificationContainer || ShowEmailBulkSendContainer || showLoggOffContainer || ShowAppsSelect || ShowNotificationCenter || isSearchActive || loading" (click)="CloseDashMenu();"></div>

<div *ngIf="ShowOverdueInvoiceNotificationContainer" class="EmailSendContainer OverdueInvoiceNotificationContainer animated fadeInDown">
    <div class="PopUpCloseContainer" (click)="ShowOverdueInvoiceNotificationContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p>{{ 'SendEmail' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">

        <div class="EmailToContainer">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'SMTP' | translate }}</mat-label>
                <mat-select disabled="true" name="SMTP" [compareWith]="compareFn" [(ngModel)]="CurrenctSMTP" required>
                  <mat-option *ngFor="let s of SMTPConfigs" [value]="s" (click)="ChangeSMTP(s);">
                    {{s.SMTPServer}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'SendFrom' | translate }}</mat-label>
                <mat-select name="FromEmail" [compareWith]="compareFn" [(ngModel)]="CurrentSMTPEmail" required>
                  <mat-option *ngFor="let e of SMTPEmails" [value]="e">
                    {{e.Email}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </div>

         <div class="EmailToContainer">
            <mat-form-field appearance="outline" class="EmailBody">
                <mat-label>{{ 'SendTo' | translate }}</mat-label>
                <textarea autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="10"
                          [(ngModel)]="this.Partner.ContactInfo.Email"></textarea>
            </mat-form-field>
         </div>

         <div class="EmailToContainer">
            <mat-form-field class="example-full-width EmailBody" appearance="outline">
                <mat-label>{{ 'SubjectEmail' | translate }}</mat-label>
                <input matInput [(ngModel)]="OverdueInvoiceNotificationEmailSubject">
              </mat-form-field>
         </div>

         <div class="EmailToContainer">
            <mat-form-field appearance="outline" class="EmailBody">
                <mat-label>{{ 'Message' | translate }}</mat-label>
                <textarea autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="10"
                          [(ngModel)]="OverdueInvoiceNotificationEmailBody"></textarea>
              </mat-form-field>
         </div>

         <div class="AttachmentsContainer">
            <span class="Attachment" *ngFor="let a of OverdueInvoiceNotificationEmailAttachments; let i=index" (click)="EliminateAttachment(a.ID);" 
            [ngClass]="{'excelAttachment': a.Name.toLowerCase().endsWith('.xls') || a.Name.toLowerCase().endsWith('.xlsx')}">
                {{a.Name}}
                <i class="material-icons">close</i>
            </span>
         </div>
       </div>

       <div class="PopUpCommands">
        <button [disabled]="loading" mat-raised-button color="primary" class="EmailSendButton" (click)="SendOverdueInvoiceNotificationEmail(); ImplementPaystub();">
          <span>
            <mat-icon class="EmailSendIcon">attach_email</mat-icon>
            {{'Send' | translate}}
          </span>
        </button>
      </div>
</div>

<div class="NotificationCenter animated fadeInDown" *ngIf="ShowNotificationCenter">
    <div class="NotificationCenterTitle">
        {{'Notifications' | translate}} {{this.Company.Name}}
    </div>
    <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowNotificationCenter = false;">close</i>
      </div>
      <div class="NotificationBody" style="padding-right: 5%;">
        <div class="NotificationRow" *ngFor="let n of this.CompanyNotifications; let i=index;">
            <div class="NotificationRowInfo">
                {{n.Message}}
            </div>
            
            <div class="NotificationRowIconsRow">
                <i class="material-icons" *ngIf="!n.IsSeen" (click)="ReadNotification(n);">mark_as_unread</i>
                <i class="material-icons" *ngIf="n.IsSeen" (click)="UnreadNotification(n);">mark_email_read</i>
                <i class="material-icons" (click)="DeleteCompanyNotification(n);">close</i>
                <a href="{{n.HyperLink}}" target="_blank">
                    <i class="material-icons" (click)="ReadNotification(n);">insert_link</i>
                </a>
            </div>
        </div>
      </div>
  
      <div class="InfoQuestionCommands">
      </div>
</div>

<div class="NotificationCenter animated fadeInDown" *ngIf="ShowAppsSelect" style="height: auto; width: 30vw; left: 35%;">
    <div class="NotificationCenterTitle">
        {{'SelectApplication' | translate}}
    </div>
    <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowAppsSelect = false;">close</i>
      </div>
      <div class="InfoQuestionBody" style="padding-right: 5%;">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'SelectApplication' | translate }}</mat-label>
            <mat-select name="SelectApplication" [(ngModel)]="AuxCurrentApp" [compareWith]="compareFn">
              <mat-option *ngFor="let app of this.Applications;" [value]="app">
                {{app.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
  
      <div class="InfoQuestionCommands" style="padding-bottom: 20px;height: auto;">
        <button mat-raised-button color="primary" class="AppChangeButton" (click)="SwitchApplication();">
            <i class="material-icons">check</i>
            {{'SelectApplication' | translate}}
        </button>
      </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="showLoggOffContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="showLoggOffContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'LogOffQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'LogOffQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button mat-raised-button class="InfoQuestionButton" (click)="showLoggOffContainer = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="showLoggOffContainer = false;LogOff();">
        <i class="material-icons">logout</i>
        {{ 'Dashboard.Menu.LogOff' | translate }}
      </button>
    </div>
</div>

<div class="DashContainer">
<div class="DashContainerTitle" style="cursor: pointer;" (click)="OpenAppsSelect();" *ngIf="this.IsMultiApp == true;">
  <div class="DashContainerTitleSelectionArea">
        <i class="material-icons">cloud_queue</i>
  </div>
  <div class="DashContainerTitleTextArea">
    <div class="DashContainerTitleTextAreaTitle">
        {{'HOME.TITLE' | translate}}
    </div>
    <div class="DashContainerTitleTextAreaSUBTitle">
        {{'Accounting' | translate}}
    </div>
  </div>
  <div class="DashContainerTitleRightIcon">
    <i class="material-icons">keyboard_arrow_down</i>
  </div>
</div>

<div class="DashContainerTitle" style="cursor:default;" *ngIf="this.IsMultiApp != true;">
    <div class="DashContainerTitleSelectionArea">
          <i class="material-icons">cloud_queue</i>
    </div>
    <div class="DashContainerTitleTextArea">
      <div class="DashContainerTitleTextAreaTitle">
          {{'HOME.TITLE' | translate}}
      </div>
      <div class="DashContainerTitleTextAreaSUBTitle">
          {{'Accounting' | translate}}
      </div>
    </div>
    <div class="DashContainerTitleRightIcon">
      
    </div>
  </div>

<div class="DashMenu">

    <div class="DashMenuItem" (click)="RedirectToURLWithUrlChange('/dashboard/stats')">
        <div class="MenuIconContainer"><i class="material-icons">home</i></div>
        <p>Dashboard</p>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('management');">
        <div class="MenuIconContainer"><i class="material-icons">dashboard</i></div>
        <p>{{ 'DashMenu.ManageMenu.Title' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('mysales');">
        <div class="MenuIconContainer"><i class="material-icons">attach_money</i></div>
        <p>{{ 'Sales' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('purchases');">
        <div class="MenuIconContainer"><i class="material-icons">addchart</i></div>
        <p>{{ 'DashMenu.PurchasesMenu.Title' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('documents');">
        <div class="MenuIconContainer"><i class="material-icons">drive_file_move_outline</i></div>
        <p>{{ 'DashMenu.DocumentsMenu.Title' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('myccpayments');">
        <div class="MenuIconContainer"><i class="material-icons">credit_card</i></div>
        <p>{{ 'CashCollectionsAndPayments' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('reports');">
        <div class="MenuIconContainer"><i class="material-icons">bar_chart</i></div>
        <p>{{ 'DashMenu.ReportsMenu.Title' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem" (click)="OpenMenu('settings');">
        <div class="MenuIconContainer"><i class="material-icons">construction</i></div>
        <p>{{ 'DashMenu.SettingsMenu.Title' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>

    <div class="DashMenuItem LogOffDashButton" (click)="OpenLogOff();">
        <div class="MenuIconContainer"><i class="material-icons">logout</i></div>
        <p>{{ 'Dashboard.Menu.LogOff' | translate }}</p>
        <i class="material-icons">keyboard_arrow_right</i>
    </div>
</div>
</div>

<div *ngIf="ShowEmailSendContainer" class="EmailSendContainer animated fadeInDown">
    <div class="PopUpCloseContainer" (click)="ShowEmailSendContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p>{{ 'SendEmail' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">

        <div class="EmailToContainer">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'SMTP' | translate }}</mat-label>
                <mat-select name="SMTP" [compareWith]="compareFn" [(ngModel)]="CurrenctSMTP" required>
                  <mat-option *ngFor="let s of SMTPConfigs" [value]="s" (click)="ChangeSMTP(s);">
                    {{s.SMTPServer}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'SendFrom' | translate }}</mat-label>
                <mat-select name="FromEmail" [compareWith]="compareFn" [(ngModel)]="CurrentSMTPEmail" required>
                  <mat-option *ngFor="let e of SMTPEmails" [value]="e">
                    {{e.Email}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </div>

         <div class="EmailToContainer">
                <mat-form-field appearance="outline" class="EmailBody">
                    <mat-label>{{ 'SendTo' | translate }}</mat-label>
                    <textarea autocomplete="off" matInput
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="10"
                              [(ngModel)]="this.EmailMessage.ToEmail"></textarea>
                </mat-form-field>
         </div>

         <div class="EmailToContainer">
            <mat-form-field class="example-full-width EmailBody" appearance="outline">
                <mat-label>{{ 'SubjectEmail' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.EmailMessage.EmailModel.Subject">
              </mat-form-field>
         </div>

         <div class="EmailToContainer">
            <mat-form-field appearance="outline" class="EmailBody">
                <mat-label>{{ 'Message' | translate }}</mat-label>
                <textarea autocomplete="off" matInput
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="10"
                          [(ngModel)]="EmailMessage.EmailModel.DefaultMessage"></textarea>
              </mat-form-field>
         </div>
       </div>

       <div class="PopUpCommands">
        <button [disabled]="loading" mat-raised-button color="primary" class="EmailSendButton" (click)="SendDocumentEmail();">
          <span>
            <mat-icon class="EmailSendIcon">attach_email</mat-icon>
            {{'Send' | translate}}
          </span>
        </button>
        <mat-slide-toggle class="AttachedDocumentSlider" [(ngModel)]="EmailMessage.SendWithAttachment">{{'AttachedDocument' | translate}}</mat-slide-toggle>
      </div>
</div>

<div *ngIf="ShowEmailBulkSendContainer" class="EmailSendContainer animated fadeInDown">
    <div class="PopUpCloseContainer" (click)="ShowEmailBulkSendContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p>{{ 'SendEmail' | translate }}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="EmailToContainer">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'SMTP' | translate }}</mat-label>
                <mat-select name="SMTP" [compareWith]="compareFn" [(ngModel)]="CurrenctSMTP" required>
                  <mat-option *ngFor="let s of SMTPConfigs" [value]="s" (click)="ChangeSMTP(s);">
                    {{s.SMTPServer}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'SendFrom' | translate }}</mat-label>
                <mat-select name="FromEmail" [compareWith]="compareFn" [(ngModel)]="CurrentSMTPEmail" required>
                  <mat-option *ngFor="let e of SMTPEmails" [value]="e">
                    {{e.Email}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
         </div>

         <div class="fullWidthContainer">
            <div class="fullWidthContainer" *ngFor="let doc of EmailDocuments">
                <div class="EmailDocument" (click)="EliminateEmailDocument(doc);">
                    <i class="material-icons">close</i>
                    {{doc.AccountingNumber.DisplayValue}} {{doc.Client?.Name}} {{doc.Supplier?.Name}} ({{doc.Client?.ContactInfo.Email}}{{doc.Supplier?.ContactInfo.Email}})
                    ({{doc.Details.EmailNotificationsCount}} {{'SendEmailNotificationsShort' | translate}})
                </div>
            </div>
         </div>
       </div>

       <div class="PopUpCommands">
        <button [disabled]="loading" mat-raised-button color="primary" class="EmailSendButton" (click)="SendInvoicesNotification();">
          <span>
            <mat-icon class="EmailSendIcon">attach_email</mat-icon>
            {{'Send' | translate}}
          </span>
        </button>
      </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showManagementMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">dashboard</i></div>
        <p>{{ 'DashMenu.ManageMenu.Title' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('management');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/partners');">
            <div class="MenuIconContainer"><i class="material-icons">supervised_user_circle</i></div>
            <p>{{ 'DashMenu.ManageMenu.ManagePartners' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>

        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/manage/products');">
            <div class="MenuIconContainer"><i class="material-icons">addchart</i></div>
            <p>{{ 'DashMenu.ManageMenu.ManageProducts' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
    
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showSalesMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">attach_money</i></div>
        <p>{{ 'Sales' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('mysales');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="OpenNewInvoice('dashboard/sales/invoice');">
            <div class="MenuIconContainer"><i class="material-icons">add</i></div>
            <p>{{ 'Invoice' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showPurchasesMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">addchart</i></div>
        <p>{{ 'DashMenu.PurchasesMenu.Title' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('myaccount');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/reception');">
            <div class="MenuIconContainer"><i class="material-icons">inventory</i></div>
            <p>{{ 'DashMenu.PurchasesMenu.Reception' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/spendings');">
            <div class="MenuIconContainer"><i class="material-icons">euro</i></div>
            <p>{{ 'Spendings' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/contract');">
            <div class="MenuIconContainer"><i class="material-icons">drive_file_rename_outline</i></div>
            <p>{{ 'PurchaseContract' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showDocumentsMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">drive_file_move_outline</i></div>
        <p>{{ 'DashMenu.DocumentsMenu.Title' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('documents');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/documents/receptions');">
            <div class="MenuIconContainer"><i class="material-icons">file_present</i></div>
            <p>{{ 'DashMenu.DocumentsMenu.Receptions' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/documents/invoices');">
            <div class="MenuIconContainer"><i class="material-icons">file_present</i></div>
            <p>{{ 'Invoices' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/documents/purchasecontracts');">
            <div class="MenuIconContainer"><i class="material-icons">file_present</i></div>
            <p>{{ 'PurchaseContractsTitle' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/documents/EFactura/Received/Invoices');">
            <div class="MenuIconContainer"><i class="material-icons">receipt_long</i></div>
            <p>{{ 'EFacturaReceivedInvoices' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showCCPMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">credit_card</i></div>
        <p>{{ 'CashCollectionsAndPayments' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('myccpayments');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/sales/cashcollections');">
            <div class="MenuIconContainer"><i class="material-icons">account_balance</i></div>
            <p>{{ 'CashCollections' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/payments');">
            <div class="MenuIconContainer"><i class="material-icons">credit_card</i></div>
            <p>{{ 'Payments' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/spendings');">
            <div class="MenuIconContainer"><i class="material-icons">euro</i></div>
            <p>{{ 'Spendings' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem">
            <div class="MenuIconContainer"></div>
            <p></p>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/purchases/upcoming/payments');">
            <div class="MenuIconContainer"><i class="material-icons">euro</i></div>
            <p>{{ 'UpcomingPayments' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/sales/upcoming/cashcollections');">
            <div class="MenuIconContainer"><i class="material-icons">euro</i></div>
            <p>{{ 'UpcomingCashCollections' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showReportsMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">bar_chart</i></div>
        <p>{{ 'DashMenu.ReportsMenu.Title' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('reports');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/reports/stockbalance');">
            <div class="MenuIconContainer"><i class="material-icons">storage</i></div>
            <p>{{ 'DashMenu.ReportsMenu.StockBalance' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
      
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/reports/taxation');">
            <div class="MenuIconContainer"><i class="material-icons">calculate</i></div>
            <p>{{ 'TaxationReport' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>

        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/reports/inventory');">
            <div class="MenuIconContainer"><i class="material-icons">inventory</i></div>
            <p>{{ 'Inventory' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashRightMenuContainer animated slideInLeft" *ngIf="showSettingsMenu">
    <div class="DashRightMenuContainerTitle">
        <div class="MenuIconContainer"><i class="material-icons">construction</i></div>
        <p>{{ 'DashMenu.SettingsMenu.Title' | translate }}</p>
        <div class="DashRightMenuCloseContainer" (click)="OpenMenu('settings');">
            <i class="material-icons">close</i>
        </div>
    </div>

    <div class="DashRightMenuBody">
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/settings/mycompany');">
            <div class="MenuIconContainer"><i class="material-icons">settings</i></div>
            <p>{{ 'DashMenu.SettingsMenu.CompanySettings' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/user/details');">
            <div class="MenuIconContainer"><i class="material-icons">account_circle</i></div>
            <p>{{ 'Dashboard.Menu.AccountSettings' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('/dashboard/users/menu');">
            <div class="MenuIconContainer"><i class="material-icons">supervised_user_circle</i></div>
            <p>{{ 'Dashboard.Menu.UsersMenu' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/settings/company/taxation/settings');">
            <div class="MenuIconContainer"><i class="material-icons">monetization_on</i></div>
            <p>{{ 'TaxationSettings' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/settings/api');">
            <div class="MenuIconContainer"><i class="material-icons">wifi</i></div>
            <p>{{ 'ConnectedAPIs' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/activity/log');">
            <div class="MenuIconContainer"><i class="material-icons">history_toggle_off</i></div>
            <p>{{ 'ActivityLog' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>

        <div class="DashMenuItem" (click)="RedirectToURL('dashboard/settings/transporters');">
            <div class="MenuIconContainer"><i class="material-icons">local_shipping</i></div>
            <p>{{ 'TransportCompanies' | translate }}</p>
            <i class="material-icons">keyboard_arrow_right</i>
        </div>
    </div>
</div>

<div class="DashContent" *ngIf="showContent == true;">
    <div class="DashContentTitleBar">
        <div class="DashContentTitleUserContainer">
            <button mat-button [matMenuTriggerFor]="menu" class="UserTopLeftButton">
                <i class="material-icons">account_circle</i>
                <span class="DisplayedCompanyEmployeeName">{{User.UIName}}</span>
                <span class="DisplayedCompanyEmployeeFunction">
                    {{Company.Department.Name}}
                </span>
            </button>
             <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="RedirectToURL('/dashboard/user/details');"><i class="material-icons">settings</i> {{ 'Dashboard.Menu.AccountSettings' | translate }}</button>
              <button mat-menu-item (click)="RedirectToURL('/dashboard/users/menu');" *ngIf="this.User.Rights.MainRole.ID >= 3;"><i class="material-icons">supervised_user_circle</i> {{ 'Dashboard.Menu.UsersMenu' | translate }}</button>
              <button mat-menu-item (click)="OpenLogOff();"><i class="material-icons">logout</i> <span>{{ 'Dashboard.Menu.LogOff' | translate }}</span></button>
             </mat-menu>
        </div>

        <div class="DashboardTitleSearchContainer">
            <input type="text" class="MainSearchInput" [(ngModel)]="this.generalSearchTerm" placeholder="{{ 'SearchIn' | translate }} {{this.Company.Alias}}" (click)="toggleSearch();" (ngModelChange)="this.searchTermUpdate.next($event)" (keydown.enter)="GetSearchResults();">
            <i class="material-icons MainSearchInputIcon" *ngIf="(this.generalSearchTerm?.length > 0) == false;">search</i>
            <i class="material-icons MainSearchInputIcon" *ngIf="(this.generalSearchTerm?.length > 0) == true;" style="cursor: pointer; color: red;" (click)="CloseDashMenu();">close</i>
                
            <div class="MainSearchResultsContainer animated fadeIn" *ngIf="((ReceptionsSearchResults != undefined && ReceptionsSearchResults.length > 0) || (InvoiceSearchResults != undefined && InvoiceSearchResults.length > 0) || (SpendingsSearchResults != undefined && SpendingsSearchResults.length > 0) || (CashCollectionsSearchResults != undefined && CashCollectionsSearchResults.length > 0) || (PurchaseContractsSearchResults != undefined && PurchaseContractsSearchResults.length > 0)) && isSearchActive == true;">
                
                <div class="MainSearchResultsOverTitle" *ngIf="InvoiceSearchResults != undefined && InvoiceSearchResults.length > 0;">
                    {{ 'Invoices' | translate }}
                    <span class="MainSearchResultsOverTitleTotal">total: {{this.InvoiceSearchResults.length}}</span>
                </div>
                <div class="MainSearchResult" *ngFor="let s of this.InvoiceSearchResults; let index = index" (click)="GoToDocumentPage(s);">
                    <div class="MainSearchTitlesContainer">
                        <div class="MainSearchResultTitle">
                            <span class="MainSearchResultTitleSpan">{{s.Title}}</span>
                        </div>
                        <div class="MainSearchResultSubTitle">
                            {{s.SubTitle}}
                        </div>
                    </div>

                    <div class="MainSearchSumContainer">
                        <div class="MainSearchTotal">{{s.Total.TotalQtyPriceVAT}}</div>
                        <div class="MainSearchCurrency">{{s.Currency.Name}}</div>
                    </div>

                    <div class="MainSearchResultCommands" *ngIf="s.CanPrint == true;">
                        <i class="material-icons SearchResultPrintCommand" (click)="PrintSearchDocument(s.DocumentID, s.SearchResultType.ID);">print</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ExportSearchDocument(s.DocumentID, s.SearchResultType.ID);">file_download</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ModifySearchDocument(s.DocumentID, s.SearchResultType.ID);">mode_edit</i>
                        <div class="SearchResultStornoRow" *ngIf="s.IsStorno == true;">storno</div>
                    </div>
                </div>

                <div class="MainSearchResultsOverTitle" *ngIf="ReceptionsSearchResults != undefined && ReceptionsSearchResults.length > 0;">
                    {{ 'DashMenu.DocumentsMenu.Receptions' | translate }}
                    <span class="MainSearchResultsOverTitleTotal">total: {{this.ReceptionsSearchResults.length}}</span>
                </div>
                <div class="MainSearchResult" *ngFor="let s of this.ReceptionsSearchResults; let index = index" (click)="GoToDocumentPage(s);">
                    <div class="MainSearchTitlesContainer">
                        <div class="MainSearchResultTitle">
                            <span class="MainSearchResultTitleSpan" style="background: #f60;">{{s.Title}}</span>
                        </div>
                        <div class="MainSearchResultSubTitle">
                            {{s.SubTitle}}
                        </div>
                    </div>
                    
                    <div class="MainSearchSumContainer">
                        <div class="MainSearchTotal">{{s.Total.TotalQtyPriceVAT}}</div>
                        <div class="MainSearchCurrency">{{s.Currency.Name}}</div>
                    </div>

                    <div class="MainSearchResultCommands" *ngIf="s.CanPrint == true;">
                        <i class="material-icons SearchResultPrintCommand" (click)="PrintSearchDocument(s.DocumentID, s.SearchResultType.ID);">print</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ExportSearchDocument(s.DocumentID, s.SearchResultType.ID);">file_download</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ModifySearchDocument(s.DocumentID, s.SearchResultType.ID);">mode_edit</i>
                        <div class="SearchResultStornoRow" *ngIf="s.IsStorno == true;">storno</div>
                    </div>
                </div>

                <div class="MainSearchResultsOverTitle" *ngIf="SpendingsSearchResults != undefined && SpendingsSearchResults.length > 0;">
                    {{ 'Spendings' | translate }}
                    <span class="MainSearchResultsOverTitleTotal">total: {{this.SpendingsSearchResults.length}}</span>
                </div>
                <div class="MainSearchResult" *ngFor="let s of this.SpendingsSearchResults; let index = index">
                    <div class="MainSearchTitlesContainer">
                        <div class="MainSearchResultTitle">
                            <span class="MainSearchResultTitleSpan" style="background: #FF999C;">{{s.Title}}</span>
                        </div>
                        <div class="MainSearchResultSubTitle">
                            {{s.SubTitle}}
                        </div>
                    </div>

                    <div class="MainSearchSumContainer">
                        <div class="MainSearchTotal">{{s.Total.TotalQtyPriceVAT}}</div>
                        <div class="MainSearchCurrency">{{s.Currency.Name}}</div>
                    </div>

                    <div class="MainSearchResultCommands" *ngIf="s.CanPrint == true;">
                        <i class="material-icons SearchResultPrintCommand" (click)="PrintSearchDocument(s.DocumentID, s.SearchResultType.ID);">print</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ExportSearchDocument(s.DocumentID, s.SearchResultType.ID);">file_download</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ModifySearchDocument(s.DocumentID, s.SearchResultType.ID);">mode_edit</i>
                        <div class="SearchResultStornoRow" *ngIf="s.IsStorno == true;">storno</div>
                    </div>
                </div>

                <div class="MainSearchResultsOverTitle" *ngIf="CashCollectionsSearchResults != undefined && CashCollectionsSearchResults.length > 0;">
                    {{ 'CashCollections' | translate }}
                    <span class="MainSearchResultsOverTitleTotal">total: {{this.CashCollectionsSearchResults.length}}</span>
                </div>
                <div class="MainSearchResult" *ngFor="let s of this.CashCollectionsSearchResults; let index = index">
                    <div class="MainSearchTitlesContainer">
                        <div class="MainSearchResultTitle">
                            <span class="MainSearchResultTitleSpan" style="background: #ADD8E6;">{{s.Title}}</span>
                        </div>
                        <div class="MainSearchResultSubTitle">
                            {{s.SubTitle}}
                        </div>
                    </div>

                    <div class="MainSearchSumContainer">
                        <div class="MainSearchTotal">{{s.Total.TotalQtyPriceVAT}}</div>
                        <div class="MainSearchCurrency">{{s.Currency.Name}}</div>
                    </div>

                    <div class="MainSearchResultCommands" *ngIf="s.CanPrint == true;">
                        <i class="material-icons SearchResultPrintCommand" (click)="PrintSearchDocument(s.DocumentID, s.SearchResultType.ID);">print</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ExportSearchDocument(s.DocumentID, s.SearchResultType.ID);">file_download</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ModifySearchDocument(s.DocumentID, s.SearchResultType.ID);">mode_edit</i>
                        <div class="SearchResultStornoRow" *ngIf="s.IsStorno == true;">storno</div>
                    </div>
                </div>

                <div class="MainSearchResultsOverTitle" *ngIf="PurchaseContractsSearchResults != undefined && PurchaseContractsSearchResults.length > 0;">
                    {{ 'PurchaseContractsTitle' | translate }}
                    <span class="MainSearchResultsOverTitleTotal">total: {{this.PurchaseContractsSearchResults.length}}</span>
                </div>
                <div class="MainSearchResult" *ngFor="let s of this.PurchaseContractsSearchResults; let index = index">
                    <div class="MainSearchTitlesContainer">
                        <div class="MainSearchResultTitle">
                            <span class="MainSearchResultTitleSpan">{{s.Title}}</span>
                        </div>
                        <div class="MainSearchResultSubTitle">
                            {{s.SubTitle}}
                        </div>
                    </div>

                    <div class="MainSearchSumContainer">
                        <div class="MainSearchTotal">{{s.Total.TotalQtyPriceVAT}}</div>
                        <div class="MainSearchCurrency">{{s.Currency.Name}}</div>
                    </div>

                    <div class="MainSearchResultCommands" *ngIf="s.CanPrint == true;">
                        <i class="material-icons SearchResultPrintCommand" (click)="PrintSearchDocument(s.DocumentID, s.SearchResultType.ID);">print</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ExportSearchDocument(s.DocumentID, s.SearchResultType.ID);">file_download</i>
                        <i class="material-icons SearchResultDownloadCommand" (click)="ModifySearchDocument(s.DocumentID, s.SearchResultType.ID);">mode_edit</i>
                        <div class="SearchResultStornoRow" *ngIf="s.IsStorno == true;">storno</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="DashboardTitleSearchSelectContainer">
            <mat-form-field appearance="outline" style="margin-top: 4px;width: 100%;" *ngIf="User.Settings.SearchResultTypes != undefined;">
                <mat-label>{{ 'SearchResultTypes' | translate }}</mat-label>
                <mat-select multiple [(ngModel)]="SearchResultTypes" [compareWith]="compareMultipleFn">
                    <mat-select-trigger>
                        {{SearchResultTypes ? SearchResultTypes[0]?.Name : ''}}
                        <span *ngIf="SearchResultTypes?.length > 1" class="example-additional-selection">
                          (+{{SearchResultTypes.length - 1}} {{'Options' | translate}})
                        </span>
                      </mat-select-trigger>
                  <mat-option *ngFor="let s of User.Settings.SearchResultTypes" [value]="s" (onSelectionChange)="changeSearchResultSelection($event);" (click)="UpdateSearchResultTypeSelection(s);">{{s.Name}}</mat-option>
                  <mat-slide-toggle class="SearchResultSlider" [(ngModel)]="SearchInProducts" (click)="UpdateSearchInProductsSetting();">{{'SearchDropDownSearchInProducts' | translate}}</mat-slide-toggle>
                </mat-select>
              </mat-form-field>
        </div>
        
        <div class="DashboardTitleSearchSelectContainer">
            <button mat-stroked-button color="primary" [matMenuTriggerFor]="fastAddMenu" class="fastAddButtonMenu">
                <i class="material-icons">add</i>
            </button>
                <mat-menu #fastAddMenu="matMenu" yPosition="below" class="fastAddMenu">
                <button mat-menu-item (click)="this.OpenNewInvoice('dashboard/sales/invoice');">
                    <i class="material-icons fastAddButtonMenuItemIcon">add</i>
                    {{ 'NewInvoice' | translate }}
                </button>
                <button mat-menu-item (click)="this.OpenNewAdvanceInvoice('dashboard/sales/invoice');">
                    <i class="material-icons fastAddButtonMenuItemIcon">add</i>
                    {{ 'AdvanceInvoice' | translate }}
                </button>
                <button mat-menu-item (click)="this.OpenNewProformaInvoice('dashboard/sales/invoice');">
                    <i class="material-icons fastAddButtonMenuItemIcon">add</i>
                    {{ 'NewProformaInvoice' | translate }}
                </button>
                <button mat-menu-item (click)="this.RedirectToURL('dashboard/purchases/reception');">
                    <i class="material-icons fastAddButtonMenuItemIcon">add</i>
                    {{ 'Receptions.NewReception' | translate }}
                </button>
                <button mat-menu-item (click)="this.RedirectToURL('dashboard/purchases/contract');">
                    <i class="material-icons fastAddButtonMenuItemIcon">add</i>
                    {{ 'PurchaseContracts.NewPurchaseContract' | translate }}
                </button>
            </mat-menu>

            <button mat-stroked-button color="primary" class="fastAddButtonMenu" (click)="OpenNotificationCenter();">
                <i class="material-icons">notifications_on</i>
                <span *ngIf="UnseenCompanyNotificationPager?.TotalCount > 0;" class="NotificationCount">{{UnseenCompanyNotificationPager?.TotalCount}}</span>
            </button>
        </div>
        
        <div class="ChangeCompanyContainer">
            <button mat-button [matMenuTriggerFor]="companiesmenu" class="ChangeCompanyMenuButton" style="padding-left: 30px;">
                <i class="material-icons ChangeCompanyMenuButtonDownArrow">keyboard_arrow_down</i>
                <p>{{Company.Name}}</p>
                <span class="DisplayedCompanyRightsContainer">
                    {{Company.MainRole.Meaning}}
                </span>
                <i class="material-icons">circle</i>
            </button>
            <mat-menu #companiesmenu="matMenu" xPosition="before">
                <p class="SelectCompaniesDropDownTitle">{{ 'Dashboard.TopBar.AssignedCompanies' | translate }}</p>
                <button class="CompanySelectVariant" mat-menu-item (click)="RedirectToURL('dashboard/companies/add');">
                    <i class="material-icons selectedCompanyIcon">add</i>
                    {{'AddNewCompany' | translate}}
                </button>
                <div *ngFor="let c of this.User.Rights.AssignedCompanies; let index = index">
                    <button class="CompanySelectVariant" mat-menu-item *ngIf="c.MainRole.ID > 0;" (click)="ChangeMainCompany(c);">
                        <i *ngIf="c.IsSelected" class="material-icons selectedCompanyIcon">circle</i>
                        {{c.Name}}
                    </button>
                </div>
            </mat-menu>
        </div>

        <div class="CompanyLogoContainer" *ngIf="this.Company?.LogoPath?.length > 0;">
            <img [src]="this.BackendServiceUrl + this.Company?.LogoPath" />
        </div>

        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <div *ngIf="LocalEnviormentWithLiveAPIWarning" class="LocalEnviormentWithLiveAPIWarning">
            <p>{{'LocalEnviormentWithLiveAPIWarning' | translate}}</p>
        </div>
    </div>

<router-outlet></router-outlet>
</div>

<div class="overlay" *ngIf="showContent != true;"></div>


